import { render, staticRenderFns } from "./FormatUnit.ts.vue?vue&type=template&id=790da12e&"
import script from "./FormatUnit.ts.vue?vue&type=script&lang=ts&"
export * from "./FormatUnit.ts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('790da12e')) {
      api.createRecord('790da12e', component.options)
    } else {
      api.reload('790da12e', component.options)
    }
    module.hot.accept("./FormatUnit.ts.vue?vue&type=template&id=790da12e&", function () {
      api.rerender('790da12e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/components/FormatUnit.ts.vue"
export default component.exports